<template>
  <div
      class="demo-screen-headline main-demo main-demo-1 spacing-top overflow-hidden reveal home-hero"
      id="home"
  >
    <div class="container px-sm-0">
      <div class="row">
        <div class="col-xl-6 col-lg-6 mb-5 pb-5 animation-zidex pos-relative hero-content">
          <h4 class="fw-semibold mt-7 text-white">
            Commission Nationale des TIPPEE
          </h4>

          <h1 class="text-start fw-bold text-white">
            Piloter les investissements publics du
            <span class="text-primary animate-heading">Gabon</span>
          </h1>

          <h6 class="pb-3 text-white-80">
            La CNTIPPEE assure la planification, le suivi et l’évaluation
            des projets d’investissements publics financés par l’État
            et ses partenaires.
          </h6>

          <router-link
              to="/projets"
              class="btn ripple btn-min w-lg mb-3 me-2 btn-primary"
          >
            <i class="fe fe-layers me-2"></i>
            Voir les projets
          </router-link>

          <router-link
              to="/a-propos"
              class="btn ripple btn-min w-lg btn-outline-light mb-3 me-2"
          >
            <i class="fe fe-info me-2"></i>
            En savoir plus
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'HomeHero'
  }
</script>

<style scoped>
.home-hero {
  position: relative;
  min-height: 70vh;

  /* IMAGE DE FOND */
  background-image:
      linear-gradient(
          rgba(0, 0, 0, 0.55),
          rgba(0, 0, 0, 0.55)
      ),
      url('/assets/images/cntppe/2.jpg');

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* Assure que le texte passe au-dessus */
.hero-content {
  position: relative;
  z-index: 2;
}

/* Texte légèrement adouci */
.text-white-80 {
  color: rgba(255, 255, 255, 0.85);
}

.landing-page .animate-heading {
  display: inline-block;
  white-space: nowrap;
  overflow: visible;
}


</style>

